import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {generateRedirectionUrl} from '../../utils';
import LocaleMenuItem from '../LocaleMenuItem/LocaleMenuItem';
import './LocaleMenuItemWrapper.less';

import {LocalizationContext} from '@homeaway/react-localization-components';

class LocaleMenuItemWrapper extends Component {
    static propTypes = {
        /** Available locale option */
        locale: PropTypes.string.isRequired,
        /** Translated language name */
        languageName: PropTypes.string.isRequired,
        /** Translated country name */
        countryName: PropTypes.string.isRequired,
        /** True for current site locale */
        isActive: PropTypes.bool,
        /** (Optional) Redirection link is dynamically generated with window.location.path. Use this attribute to provide a value for the redirection link instead of the default link generated. */
        link: PropTypes.string,
        /** BasePath for this locale option */
        basePath: PropTypes.string
    };

    static defaultProps = {
        locale: 'en_US',
        languageName: 'English',
        countryName: 'United States',
        isActive: false,
        basePath: ''
    };

    static contextType = LocalizationContext;

    constructor(props) {
        super(props);

        this.state = {
            link: props.link
        };
    }

    componentDidMount() {
        let link = generateRedirectionUrl({
            path: `${window.location.pathname}${window.location.search}`,
            basePath: this.props.basePath,
            currentBasePath: this.context.basePath || '',
            link: this.props.link
        });

        this.setState({link});
    }

    get currentLocale() {
        return this.context.locale ? this.context.locale.substr(0, 5) : 'en_US';
    }

    render() {
        return (
            <a href={this.state.link} className={'LocaleMenuItemWrapper'}>
                <LocaleMenuItem
                    locale={this.props.locale}
                    countryName={this.props.countryName}
                    languageName={this.props.languageName}
                    isActive={this.props.isActive || this.currentLocale === this.props.locale}
                />
            </a>
        );
    }
}

export default LocaleMenuItemWrapper;
